var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":"#e21b23","value":_vm.error.show}},[_vm._v(" "+_vm._s(_vm.error.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }